import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import * as CertificadoApi from 'api/certificado';
import { getResponseError } from 'util/errorHelper';

export const ConsultaContext = createContext({
  data: null,
  loading: false,
  error: null,
  fetch: () => {},
  clear: () => {},
});

export const ConsultaContextProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async (codigo) => {
    setError(null);
    setLoading(true);
    try {
      const { data: res } = await CertificadoApi.validar(codigo);
      setData(res);
    } catch (err) {
      setError(getResponseError(err));
    } finally {
      setLoading(false);
    }
  }, [setData, setLoading, setError]);

  const clear = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, [setData, setLoading, setError]);

  return (
    <ConsultaContext.Provider value={{
      data,
      loading,
      error,
      fetch,
      clear,
    }}
    >
      {children}
    </ConsultaContext.Provider>
  );
};

ConsultaContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
